module.exports = __webpack_public_path__ + "img/yml_gallery19.0867ade8.jpg";